<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <v-icon medium>
          mdi-lock
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">Account Lock</span>
      </v-col>
    </v-row>
  
    <v-row
      v-if="loading"
      no-gutters
    >
      <v-col>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </v-row>

    <div v-else>
      <v-row v-if="edit">
        <v-col cols="6">
          <v-checkbox
            v-model="form.account_locked"
            v-validate="'required'"
            :error-messages="errors.collect('account_locked')"
            data-vv-name="account_locked"     
          >
            <template v-slot:label>
              <div>
                Account Lock
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <span class="font-weight-medium pr-3">Account Locked: </span>

          <span
            v-if="user.account_locked === 1"
            class="font-weight-bold"
            style="color:red"
          >
            YES
          </span>
          <span
            v-else
            class="font-weight-bold"
            style="color:green"
          >
            NO
          </span>
        </v-col>
      </v-row>
    </div>

    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="primary"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        edit: false,
        user: {},
        form: {
          account_locked: 0,
        },
      }
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserSystemAccess()
          }
        },
      },
    },
    methods: {    
      submitForm () {
        this.progressing = true

        this.$api.passwordAttempts().update(this.userUid, this.prepareFormData())
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              Object.keys(this.form).map(key => {
                this.$set(this.user, key, this.form[key] ? 1 : 0)
              })

              this.edit = false

              this.$snack({
                message: response.data.status,
              })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      loadUserSystemAccess () {
        this.loading = true

        this.$api.passwordAttempts().list(this.userUid)
          .then(response => {            
            this.user = response.data          
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.user[key] === 1
        })

        this.edit = true
      },
      prepareFormData () {
        return {
          account_locked: this.form.account_locked ? 1 : 0,
        }
      },
    },
  }
</script>

<style scoped>
.font-16{
  font-size:16px;
}
</style>
